/**
 * Created by senani on 12/18/18.
 */

import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./Cart.css";
import "../../Common/ResponsiveCart.css";
import CartTable from "./CartTable/CartTable";
import CartPrint from "./CartPrint/CartPrint";
import CartBottom from "./CartBottom/CartBottom";
import StencilCustomizedSize from "../QuotationForm/StencilQuotationForm/StencilCustomizedSize/StencilCustomizedSize";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import {BASE_URL, IS_IN_MOBILE_MODE, PAGE_OPEN_TYPE, RESOURCE_BASE_URL} from "../../../configuration";
import axios from "axios";
import GoogleAds from "../../Common/GoogleAds/GoogleAds";
import CartMobileView from "./CartMobileView/CartMobileView";
import CartPagination from "./CartPagination";
import PriceLoadingImage from "../../../assets/img/loading_price.gif";

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // userId: (props.keycloak) ? props.keycloak.subject : "",
            userId: "",
            fileKey: "",
            cartId: "",
            checkedItems: [],
            pagedCartItems : [],
            isGettingPagedCartItems : true,
            page :0,
            activePage: 1,
            itemCountPerPage : 5,
            totalItemsCount: 0,
            counter : 0,
            allCheckedFlag : false,
            pagedCartItemIds : []
        };

        this.setAllCartItemsChecked = this.setAllCartItemsChecked.bind(this);
        this.launchAddToCart = this.launchAddToCart.bind(this);
        this.toggleAllItems = this.toggleAllItems.bind(this);
        this.toggleItem = this.toggleItem.bind(this);
        this.delayedAddToCart = this.delayedAddToCart.bind(this);
        this.getPagedCartItems = this.getPagedCartItems.bind(this);
        this.setPageForItems = this.setPageForItems.bind(this);
        this.onCartItemDeleted = this.onCartItemDeleted.bind(this);
    }

    componentDidMount() {
        let elm = document.getElementById('overlay-cart-loading-starter-img');

        if(elm !== null){
            elm.style.paddingTop = '65px';
        }

        if (localStorage.getItem("userId") !== null) {
            this.setState({userId: localStorage.getItem("userId")});
            if(localStorage.getItem("ci") !== null){
                this.delayedAddToCart();
            }
            // window.location.reload();
        } else {
            window.location.replace(BASE_URL + 'login');
        }

        let url = window.location.href;
        let windowUrl = new URL(url);
        if (windowUrl.searchParams.has("key")) {
            let fileKey = windowUrl.searchParams.get("key");
            this.setState({
                fileKey
            });
        }
        // this.setAllCartItemsChecked();

        setTimeout(()=>{
            this.getPagedCartItems();
            this.props.getCartItems();

        }, 4500)

    }

    setPageForItems = (offset) => {
        window.scrollTo(0,0);
        let counter = this.state.counter;
        console.log(offset);
        if(offset > this.state.activePage){
            counter += 5;
        }else if(this.state.activePage === 1){
            counter = 0;
        }else if(offset < this.state.activePage){
            counter -= 5;
        }

        this.setState({
            counter,
            page : offset-1,
            activePage : offset,
        }, ()=>this.getPagedCartItems())
    };

    delayedAddToCart() {

        if(localStorage.getItem("ci") !== null){
            let savedItem = localStorage.getItem("ci");
            let savedCartItem = JSON.parse(savedItem);

            console.log("STORAGE CART ITEM DUO ===== > ", savedCartItem);

            this.launchAddToCart(savedCartItem);
        }
    };

    launchAddToCart = (orderItemJson) => {
        // localStorage.setItem("ci", null);
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let cartResourceUrl = RESOURCE_BASE_URL + 'api/users/' + localStorage.getItem("userId") + '/cart';

        // console.log("ADD TO CART REQUEST DUO ====> ", orderItemJson);

        axios.post(cartResourceUrl, orderItemJson, axiosConfig)
            .then((res) => {
                localStorage.setItem("ci", null);
                this.getPagedCartItems();
                this.props.getCartItems();
                // console.log("ADD TO CART WITH LOCAL STORAGE ==== >", res.data);
            })
            .catch((err) => {
                this.getPagedCartItems();
                this.props.getCartItems();
                localStorage.setItem("ci", null);
                console.log("[API] ERROR: ", err);
            });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});

        }
        if (prevProps.cartItems !== this.props.cartItems) {
            // this.setAllCartItemsChecked();
        }
    }

    setAllCartItemsChecked = () => {
        let checkedItems = this.state.pagedCartItems.map((item) => {
            return item.id;
        });

        this.setState({checkedItems});
    };

    toggleAllItems = () => {
        // let allChecked = this.state.pagedCartItems.length === this.state.checkedItems.length;


        let checkedItems = [...this.state.checkedItems];

        let allChecked = true;

        this.state.pagedCartItemIds.forEach(value => {
            if(allChecked){
                if(this.state.checkedItems.includes(value)){
                    allChecked = true;
                }
                else {
                    allChecked = false;
                }
            }
        });

           this.state.pagedCartItemIds.forEach(value => {
               if(allChecked){
               if(this.state.checkedItems.includes(value)){
                   checkedItems.splice(checkedItems.indexOf(value),1);
               }
               }else {
                   checkedItems.push(value);
               }
           });


        let uniqueItems = checkedItems.reduce((unique, item)=>unique.includes(item) ? unique : [...unique, item], []);


        // let checkedItems = (allChecked) ? [] : this.state.pagedCartItems.map((item) => item.id);
        this.setState({checkedItems : uniqueItems}, ()=>{console.log("CHECKED ITTTTT ===> ",this.state.checkedItems)});
    };

    toggleItem = (id) => {
        let checkedItems = [...this.state.checkedItems];

        if (this.state.checkedItems.includes(id)) {
            checkedItems.splice(checkedItems.indexOf(id), 1);
        } else {
            checkedItems.push(id);
        }

        this.setState({checkedItems});
    };

    onCartItemDeleted = () => {
        let activePage = this.state.activePage;
        let setActivePage = 1;

        if(activePage > 1){
            setActivePage = activePage;
        }
        if(activePage > 1 && this.state.pagedCartItems.length === 1){
            setActivePage = activePage -1;
        }

        this.setState({
            page :setActivePage-1,
            activePage: setActivePage,
            itemCountPerPage : 5,
            totalItemsCount: 0,
            counter : 0
        }, ()=>{
            this.getPagedCartItems();
            this.props.getCartItems();
        })
    };

    getPagedCartItems = () => {
        if(IS_IN_MOBILE_MODE){
            this.setState({
                pagedCartItems:[],
                totalItemsCount : 0,
                isGettingPagedCartItems : true
            });
        }else {
            this.setState({

                isGettingPagedCartItems : true
            });
        }

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let elm = document.getElementById('overlay-cart-loading-starter-img');

            let cartResourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.state.userId + '/cart/items/paged?offset='+this.state.page+'&limit='+this.state.itemCountPerPage;

        axios.get(cartResourceUrl, axiosConfig)
            .then((res) => {
                console.log("PAGED CART ITEMS =====> ", res.data);
               if(elm !== null){
                   elm.style.paddingTop = '200px';
               }

               let pagedCartItemIds = [];
                res.data.cartItems.forEach(value => {
                        pagedCartItemIds.push(value.id);
                });

                this.setState({
                    pagedCartItems:res.data.cartItems,
                    totalItemsCount : res.data.rowCount,
                    isGettingPagedCartItems : false,
                    pagedCartItemIds
                }, ()=>{
                    window.scrollTo(0,0);
                    console.log("PAGED ITEM IDS ===> ", this.state.pagedCartItemIds);
                    console.log("SELECTED ITEM IDS ===> ", this.state.checkedItems);
                }
                    )
                // console.log("ADD TO CART WITH LOCAL STORAGE ==== >", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                setTimeout(()=>{
                    if(elm !== null){
                        elm.style.paddingTop = '200px';
                    }
                },1000)
                console.log("Token invalid");
                localStorage.clear();
                window.location.replace(BASE_URL + "login");
            });
    };

    render() {

        let allChecked = true;

        this.state.pagedCartItemIds.forEach(value => {
           if(allChecked){
               if(this.state.checkedItems.includes(value)){
                   allChecked = true;
               }
               else {
                   allChecked = false;
               }
           }
        });

        return (
            <div className="shopping-cart-content">
                <GoogleAds slot="696274611" />
                <div className="row row-resp">
                    <div className="col-md-9">
                        {!IS_IN_MOBILE_MODE ?
                            <span>
                                {this.state.isGettingPagedCartItems ?
                                    <div className="overlay-cart-loading">
                                        <img className="" id="overlay-cart-loading-starter-img" src={PriceLoadingImage} alt="お待ちください。カートアイテムの取得..."/>
                                    </div> : ''
                                }
                            </span> : ''
                        }

                        <div className="shopping-cart-div no-padding-right no-margin-right">
                            <div className="row">
                                <div className="title-1 col-md-6">
                                    <FormattedMessage id="app.cart.title"
                                                      defaultMessage="SHOPPING CART"
                                                      description=""/></div>

                                <div className="pull-right col-md-1 col-md-offset-5">
                                    {/*<CartPrint itemDetails={this.props.cartItems}
                                       userId={this.state.userId}
                                       getCartItems={this.props.getCartItems}
                                       checkedItems={this.state.checkedItems}
                            />*/}
                                </div>
                            </div>
                            <div className="spacer"></div>



                            <CartTable cartItems={this.state.pagedCartItems}
                                       getCartItems={this.getPagedCartItems}
                                       userId={this.state.userId}
                                       fileKey={this.state.fileKey}
                                       checkedItems={this.state.checkedItems}
                                       toggleAllItems={this.toggleAllItems}
                                       toggleItem={this.toggleItem}
                                       isGettingCartItems = {this.state.isGettingPagedCartItems}
                                       activePage={this.state.activePage}
                                       itemsCountPerPage={this.state.itemCountPerPage}
                                       totalItemsCount={this.state.totalItemsCount}
                                       handlePageChange={this.setPageForItems}
                                       onCartItemDeleted = {this.onCartItemDeleted}
                                       allChecked = {allChecked}
                            />

                        </div>
                        <div className="shopping-cart-mobile-view">
                            <CartMobileView
                                cartItems={this.state.pagedCartItems}
                                getCartItems={this.getPagedCartItems}
                                userId={this.state.userId}
                                fileKey={this.state.fileKey}
                                checkedItems={this.state.checkedItems}
                                toggleAllItems={this.toggleAllItems}
                                toggleItem={this.toggleItem}
                                isGettingCartItems = {this.state.isGettingPagedCartItems}
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemCountPerPage}
                                totalItemsCount={this.state.totalItemsCount}
                                handlePageChange={this.setPageForItems}
                                counter = {this.state.counter}
                                onCartItemDeleted = {this.onCartItemDeleted}
                                allChecked = {allChecked}
                            />
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="col-md-12 summary-cart-div no-padding">
                            <div className="cart-bottom2-div">
                                <CartBottom
                                    itemLength={this.state.checkedItems.length}
                                    getCartItems={this.getPagedCartItems}
                                    cartItems = {this.state.pagedCartItems}
                                    userId = {this.state.userId}
                                    fileKey = {this.state.fileKey}
                                    checkedItems = {this.state.checkedItems}
                                />
                            </div>

                        </div>
                    </div>
                    {/*<div className="col-md-3 summary-cart-div no-padding">*/}
                        {/*<div className="cart-bottom2-div">*/}
                            {/*<CartBottom*/}
                                {/*itemLength={this.state.checkedItems.length}*/}
                                {/*getCartItems={this.props.getCartItems}*/}
                                {/*cartItems = {this.props.cartItems}*/}
                                {/*userId = {this.state.userId}*/}
                                {/*fileKey = {this.state.fileKey}*/}
                                {/*checkedItems = {this.state.checkedItems}*/}
                            {/*/>*/}
                        {/*</div>*/}

                    {/*</div>*/}
                </div>
            </div>
        )
    }
}

export default Cart;




// WEBPACK FOOTER //
// ./src/components/Site/Cart/Cart.js